import { TEssenceGroups } from '@lib/core/characters/types/essences';

export const selectEssenceGroups = (state, defaultValue = []): TEssenceGroups[] =>
  state?.essenceGroups?.data || defaultValue;

export const selectEssenceGroupsLoading = (state, defaultValue = false): boolean =>
  state?.essenceGroups?.isLoading || defaultValue;
